<cu-workflow-progress
  *ngIf="page.helper.hasProgressBar"
  [title]="pageTitle"
  [progress]="progress()"
  [footer]=""
  [flowType]="flowType"
  >
</cu-workflow-progress>
<div id="workflow-progress-sticky-spacer" class="bl-padding-y--32"></div>